import React, { useState } from 'react'
import { Link } from 'react-router-dom';

function Youtube() {

    const [video, setVideo] = useState();

    return (
        <>            
                        
                            {/* <div className="bsingle__post mb-50">
                                <div className="bsingle__post-thumb video-p">
                                    <img src="assets/img/blog/inner_b2.jpg" alt="" />
                                    <Link to="#" className="video-i popup-video" onClick={() => setVideo(true)} >
                                        <i className="fas fa-play" />
                                    </Link>
                                </div>
                                
                            </div> */}
                        <div className="bsingle__post mb-50">
                            <div className="s-about-img p-relative  wow fadeInLeft animated bsingle__post-thumb video-p" data-animation="fadeInLeft" data-delay=".4s" >
                                <img src="assets/img/features/about_img_02.png" alt="img" />
                                <div className='s-video-content'>
                                <Link to="#" aria-label='IITT Campus Video' className="video-i popup-video" onClick={() => setVideo(true)} >
                                    <i className="fas fa-play" />
                                    {/* <img src="assets/img/bg/play-button2.png" alt="circle_right" onClick={() => setVideo(true)} /> */}
                                </Link>
                                </div>
                            </div>
                        </div>
                   
                        
            {video &&
                <>
                    <div className="mfp-bg mfp-ready"></div>
                    <div className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready" tabindex="-1" style={{ overflow: "hidden" }}>
                        <div className="mfp-container mfp-s-ready mfp-iframe-holder">
                            <div className="mfp-content">
                                <div className="mfp-iframe-scaler">
                                    <button title="Close (Esc)" type="button" className="mfp-close" onClick={() => setVideo(false)} >×</button>
                                    {/* <iframe className="mfp-iframe" src="//www.youtube.com/embed/V0iNMuPV9Z8?autoplay=1" frameborder="0" allowfullscreen=""></iframe> */}
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/V0iNMuPV9Z8?si=uVOfYBHtXn6Ld113&amp;controls=0&amp;start=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                    
                                </div>
                            </div>
                            <div className="mfp-preloader">Loading...</div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default Youtube